import HeaderContent from "component/layout/HeaderContent";
import React from "react";
import TopHeader from "../HomePage/component/TopHeader";
import AdvicePage from './AdvicePage';

export default function AdvicePageRouter() {
  return (
    <HeaderContent>
      <TopHeader />

      <AdvicePage />
    </HeaderContent>
  );
}
